// extracted by mini-css-extract-plugin
module.exports = {"button":"search-button_button__q67Fq","icon":"search-button_icon__Kdnmv"};